import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTipoAtraso = (id) => async (dispatch) => {
  await Instance()
    .get(`/tipoatrasos/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOATRASO', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTipoAtraso;
